<section
  class="cms-section"
  [ngClass]="{ 'new-section': showNew }"
  id="appCMSLinks-section-popularCities"
  *ngIf="links"
>
  <div
    class="cms-links"
    [ngClass]="{
      'city-view': !isLDP && !isLandingPage,
      'non-city-view': isLDP || isLandingPage,
      'full-height': showMore
    }"
  >
    <h2 class="title">{{ title }}</h2>

    <hr class="hide-on-mobile" />

    <div
      class="links is-flex"
      [class.is-flex]="screenSize !== SCREEN_SIZE.MOBILE_ONLY"
    >
      <ng-container *ngIf="(isLDP || isLandingPage) && popularCities">
        <div *ngIf="popularCities" class="popular-cities">
          <a
            *ngFor="let city of popularCities"
            [href]="city.url"
            class="popular-city-link"
          >
            {{ city.name }}
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="!isLDP && !isLandingPage">
        <div *ngIf="links?.popularCities" class="popular-cities-city-page">
          <a
            *ngFor="let city of links.popularCities.slice(0, 100)"
            [href]="city.url"
            class="popular-city-link-city-page"
          >
            {{ city.name || city.title}}
          </a>
        </div>
      </ng-container>
    </div>
  </div>
  <div 
    *ngIf="!isLDP && !isLandingPage" 
    class="links text-center" 
    [ngClass]="{
      'full-height': showMore
    }"
  >
    <span
      (click)="toggleShowMore()"
      role="button"
      tabindex="0"
      (keydown.enter)="showMore = !showMore"
    >
      <span>
        {{ 
          ( showMore ? "relevant-links.show-less-links" : "relevant-links.show-more-links")  | translate
        }} 
        <i class="material-icons v-align" *ngIf="!showMore">keyboard_arrow_down</i> 
        <i class="material-icons v-align" *ngIf="showMore">keyboard_arrow_up</i>
      </span>
    </span>
  </div>
</section>
